<div [class.visible]="visible">
  <ul [class.is_scrolling]="is_scrolling">
    <li *ngFor="let item of items" [ngClass]="item.classes || ''">
      <a [innerText]="item.title" (click)="close(true, item)"> </a>
    </li>
  </ul>
</div>
